import { render, staticRenderFns } from "./myobConfigDialog.vue?vue&type=template&id=4a89e199&"
import script from "./myobConfigDialog.vue?vue&type=script&lang=js&"
export * from "./myobConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports